<template>
  <v-snackbar
    style="height: 100%"
    centered
    v-model="alert.show"
    :color="alert.variant"
    :timeout="alert.dismissCountDown == 0 ? -1 :  alert.dismissCountDown"
  >
    <v-row dense class="d-flex">
      <v-col class="align-self-center" style="font-size: 18px;" v-html="alert.message"></v-col>
      <v-col cols="1">
        <!-- <template v-slot:action="{ attrs }"> -->
        <v-btn fab elevation="0" color="white" @click="closeAlert" x-small>
          <v-icon color="black">mdi-close</v-icon>
        </v-btn>
        <!-- <v-btn
            icon
            v-bind="attrs"
            @click="closeAlert"
            color="white"
          >
            <v-icon>mdi-close</v-icon>
        </v-btn>-->
        <!-- </template> -->
      </v-col>
    </v-row>
  </v-snackbar>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "Alert",
  data() {
    return {
      snackbar: true
    };
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    closeAlert() {
      this.setAlert({
        show: false,
        variant: "",
        message: "",
        dismissCountDown: 0
      });
    }
  },
  computed: {
    ...mapState("utils", ["alert"])
  }
};
</script>

<style>
</style>